// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3LoFj","info":"Note_info__2_K1f","note":"Note_note__2kL3p","actions":"Note_actions__2t9sx"};